
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { AgGridActionbutton } from 'src/app/shared/common/AgGridActionbutton';
import { GenericBadgeRendererComponent } from 'src/app/shared/common/generic-badge-renderer.component';
import { AlertRuleService } from 'src/app/shared/services/alert-rule.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';


interface Product {
  name?: string;
  id?:any;
}

@Component({
    selector: 'app-alert-product-mapping',
    templateUrl: './alert-product-mapping.component.html',
    styleUrls: ['./alert-product-mapping.component.scss'],
    standalone: false
})
export class AlertProductMappingComponent implements OnInit {
  
  /* ===============================
     AG GRID ENHANCED
  =============================== */
  
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

   

  components: any={
        buttonRenderer: AgGridActionbutton
      }

  columnDefs: ColDef[] = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 100,
      pinned: 'left',
      lockPosition: true,
      onCellClicked: (event: any) => this.onCellClicked(event)
      // cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' }
    },
    { 
      headerName: 'Products',
      headerTooltip: 'Products', 
      field: 'product',
      sortable: true,
      tooltipValueGetter: (params) => 'Products : ' + params.value,
      filter: 'agTextColumnFilter'
    },
    { 
      headerName: 'Alert Rule Name',
      headerTooltip: 'Alert Rule Name',  
      field: 'ruleName',
      sortable: true,
      tooltipValueGetter: (params) => 'Alert Rule Name : ' + params.value,
      filter: 'agTextColumnFilter'
    },
     { 
      headerName: 'Description',
      headerTooltip: 'Description',  
      field: 'description',
      width:200,
      sortable: true,
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      filter: 'agTextColumnFilter'
    },
     {
        headerName: "Logic Expression",
        headerTooltip: 'Logic Expression', 
        field: "logicExpression",
        valueFormatter: (params: any) => {
          if (!params.data.logicExpression) return "-";
          try {
            return this.buildLogicText(JSON.parse(params.value));
          } catch (e) {
            console.error(e, "Not Valid Json Displaying Original Value ");
            return params.data.logicExpression;
          }
        },
        tooltipValueGetter: (params: any) => {
          if (!params.value) return "-";

          let readable = "";
          let raw = params.value;

          try {
            readable = this.buildLogicText(JSON.parse(params.value));
          } catch (e) {
            console.error(e, "Not Valid Json Displaying Original Value");
            readable = params.value;
          }

          return `Logic Expression: ${readable}`;
        },

        width: 250,
      },
    { 
      headerName: 'Type', 
      headerTooltip: 'Type', 
      field: 'type',
      width:120,
      sortable: true,
      tooltipValueGetter: (params) => 'Type : ' + params.value,
      filter: 'agSetColumnFilter'
    },
    { 
      headerName: 'Data Source',
      headerTooltip: 'Data Source',  
      field: 'source',
      width:200,
      sortable: true,
      tooltipValueGetter: (params) => 'Data Source : ' + params.value,
      filter: 'agSetColumnFilter'
    },
    { 
      headerName: 'Periodicity',
      headerTooltip: 'Periodicity',  
      field: 'periodicity',
      width:200,
      sortable: true,
      tooltipValueGetter: (params) => 'Periodicity : ' + params.value,
      filter: 'agSetColumnFilter'
    },
      {
        headerName: 'Mapping Rule',
        headerTooltip: 'Mapping Rule', 
        field: 'mapping',
        width: 200,

        tooltipValueGetter: (params) => 'Mapping Rule : ' + params.value,

        cellRenderer: GenericBadgeRendererComponent,
        cellRendererParams: { type: 'MAPPING_RULE' },

        // Custom filter value getter to ensure filtering works based on the displayed badge value
        filterValueGetter: (params: any) => {
          const v = (params.data?.mapping || '').toLowerCase();

          if (v === 'auto') return 'A Auto';
          if (v === 'manual') return 'M Manual';
          return 'NM Not Mapped';
        }
      },
    {
      headerName: 'Exception Rule',
      headerTooltip: 'Exception Rule', 
      field: 'exception',
       width:200,
       tooltipValueGetter: (params) => 'Exception Rule : ' + params.value,
       cellRenderer: GenericBadgeRendererComponent,
        cellRendererParams: { type: 'YES_NO' }
    },
    // {
    //   headerName: 'STATUS',
    //    width:120,
    //   field: 'status',
    //    tooltipValueGetter: (params) => 'STATUS : ' + params.value,
    //    cellRenderer: GenericBadgeRendererComponent,
    //     cellRendererParams: { type: 'YES_NO' }
    // },
    // {
    //   headerName: '', 
    //   filter: false, 
    //   width:120,
    //   cellRenderer: 'buttonRenderer',
    //   pinned:'right',
    //   lockPinned:true,
    //   cellRendererParams: {
    //     // edit: this.EditIcon.bind(this),
    //     // delete: this.deleteIcon.bind(this),
    //   }, 
    // }
    // {
    //   headerName: 'ACTIONS',
    //   field: 'actions',
    //   width: 100,
    //   pinned: 'right',
    //   lockPosition: true,
    //   cellRenderer: (params: any) => `
    //     <div class="row-actions">
    //       <i class="pi pi-pencil edit" title="Edit" data-action="edit" data-id="${params.data.id}"></i>
    //       <i class="pi pi-trash delete" title="Delete" data-action="delete" data-id="${params.data.id}"></i>
    //     </div>
    //   `,
    //   onCellClicked: (event: any) => this.onCellClicked(event)
    // }
  ];

  defaultColDef: ColDef = {
      sortable: true,
      resizable: true,
      filter: true,
      filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      }
    };

  rowData = [];

  gridApi: GridApi | null = null;
  isGridLoading = true;
  private destroy$ = new Subject<void>();
  private searchSubject = new Subject<string>();

  /* ===============================
     PRIME NG FILTER DATA ENHANCED
  =============================== */

  productOptions : Product[] = [];

  alertOptions = [
    // { label: 'All Alerts', value: null },
    // { label: 'Company DB', value: 'Company DB' },
    // { label: 'FDA Alert', value: 'FDA Alert' },
    // { label: 'SDR Geriatr', value: 'SDR Geriatr' },
    // { label: ' SDR EB05 All', value:  'SDR EB05 All' },
  ];

  dataSourceOptions = [

    { label: 'FAERS', value: 'FAERS' },
    { label: 'EVDAS', value: 'EVDAS' },
    { label: 'Safety Database', value: 'Safety Database' },
    { label: 'VigiBase', value: 'VigiBase' },
  ];

  selectedProducts: any[] = [];
  totalProducts : number = 0;
  totalAlerts : number = 0;
  activeAlerts : number = 0;
  mappedProducts : number = 0;
  unmappedProducts : number = 0;
  defaultCount : number = 0;
  
  pageSize = 50;
  currentPage = 1;
  totalPages = 1;
  totalRows = 0;
  startRow = 1;
  endRow = 50;
  selectedProductId: any;
  selectedSource: any=null;
  selectedAlertId: any;
  ruleType: string; // 'Auto' or 'Manual' or 'Not Mapped'


  showUnMappedProducts=false
  constructor(private alertRuleService: AlertRuleService,
                  private snackBar: MatSnackBar,
                  private spinner: NgxUiLoaderService,
                  private jsignalsService: JsignalService,
                  private localStorageSettings: LocalStorageSettingsService,
  ) {}

  ngOnInit(): void {
    this.loadSummaryData();
    this.loadProductList();
    this.loadAllActiveAlerts();
    // Debounce search for better performance
    this.searchSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$)
    ).subscribe(searchTerm => {
      if (this.gridApi) {
        this.gridApi.setGridOption('quickFilterText',searchTerm);
      }
    });
  }

  /* ===============================
     GRID EVENTS
  =============================== */

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.isGridLoading = false;
    
    // Auto-size columns on load
    setTimeout(() => {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    }, 100);

    // Add click event listener for action buttons
    params.api.addEventListener('cellClicked', (event: any) => {
      if (event.column.colId === 'actions') {
        this.onCellClicked(event);
      }
    });
  }

  EditIcon(event){

  }
  deleteIcon(event){

  }
  onSelectionChanged(event: SelectionChangedEvent): void {
    this.selectedProducts = event.api.getSelectedRows();
  }

  /* ===============================
     CELL CLICK HANDLER
  =============================== */

  onCellClicked(event: any): void {
    const target = event.event.target as HTMLElement;
    
    // Check if clicked element is an action button
    if (target.classList.contains('pi')) {
      const action = target.getAttribute('data-action');
      const id = target.getAttribute('data-id');
      const rowData = event.data;
      
      if (action === 'edit') {
        this.onEditRow(rowData);
      } else if (action === 'delete') {
        this.onDeleteRow(rowData);
      }
    }
  }

  /* ===============================
     SEARCH HANDLER ENHANCED
  =============================== */

  onSearch(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }

  clearSearch(inputElement: HTMLInputElement): void {
    inputElement.value = '';
    this.searchSubject.next('');
  }

  /* ===============================
     BULK SELECTION ENHANCED
  =============================== */

  getSelectedCount(): number {
    return this.selectedProducts.length;
  }

  clearSelection(): void {
    if (this.gridApi) {
      this.gridApi.deselectAll();
      this.selectedProducts = [];
    }
  }

  onCreate(): void {
    console.log('Create new mapping');
    // Implement create logic here
  }

  onMapSelected(): void {
    console.log('Map selected items:', this.selectedProducts);
    const DnsName = this.localStorageSettings.getSettings("dnsName");
    const Workspaceid = this.localStorageSettings.getSettings("WorkspaceId");
 
      // Only NOT_MAPPED rows should be mapped
  const selectedRows = this.gridApi.getSelectedRows();    
  const rowsToMap = selectedRows
    .filter(row => row.mapping === 'Not Mapped')
    .map(row => ({
      productId: row.id,
      ruleId: row.ruleId
    }));

  if (rowsToMap.length === 0) {
    return;
  }
  this.spinner.start();

  this.alertRuleService.manualMapALLSelectedProductToAlertRule(rowsToMap, DnsName, Workspaceid)
    .subscribe({
      next: (res) => {
        console.log('Bulk Map Success', res);
        this.clearSelection();
        this.loadGridData(); // refresh grid
         this.loadSummaryData();
        this.snackBar.open(res.statusMessage,"Ok", { duration: 3000 });
        this.spinner.stop();
      },
      error: (err) => {
        console.error('Bulk Map Failed', err);
         this.loadSummaryData();
         this.snackBar.open(err.error.statusMessage,"Ok", { duration: 3000 });
         this.spinner.stop();
      }
    });
  }

  onUnmapSelected(): void {

  const selectedRows = this.gridApi.getSelectedRows();

  if (!selectedRows || selectedRows.length === 0) {
    return;
  }

  // Only MANUAL rows should be unmapped
  const rowsToUnmap = selectedRows
    .filter(row => row.mapping === 'Manual')
    .map(row => ({
      productId: row.id,
      ruleId: row.ruleId
    }));

  if (rowsToUnmap.length === 0) {
    return;
  }
this.spinner.start();
  this.alertRuleService.manualUnMapALLSelectedProductToAlertRule(rowsToUnmap)
    .subscribe({
      next: (res) => {
        console.log('Bulk Unmap Success', res);
        this.clearSelection();
        this.loadGridData(); // refresh grid
         this.loadSummaryData();
         this.snackBar.open(res.statusMessage,"Ok", { duration: 3000 });
         this.spinner.stop();
      },
      error: (err) => {
        console.error('Bulk Unmap Failed', err);
         this.loadSummaryData();
         this.snackBar.open(err.error.statusMessage,"Ok", { duration: 3000 });
          this.spinner.stop();
      }
    });
}

  onEditSelected(): void {
    console.log('Edit selected items:', this.selectedProducts);
    // Implement edit logic here
  }

  onDeleteSelected(): void {
    if (this.selectedProducts.length === 0) return;
    
    if (confirm(`Are you sure you want to delete ${this.selectedProducts.length} items?`)) {
      console.log('Delete selected items:', this.selectedProducts);
      // Implement delete logic here
      this.clearSelection();
    }
  }

  getSelectedRows(): any[] {
  return this.gridApi?.getSelectedRows() || [];
}

  hasAutoSelected(): boolean {
  return this.getSelectedRows().some(row => row.mapping === 'Auto');
}

canMapSelected(): boolean {
  const rows = this.getSelectedRows();
  return rows.length > 0 && !this.hasAutoSelected();
}

hasManualSelected(): boolean {
  return this.getSelectedRows().some(r => r.mapping === 'Manual');
}

hasNotMappedSelected(): boolean {
  return this.getSelectedRows().some(r => r.mapping === 'Not Mapped');
}

isMixedSelection(): boolean {
  return this.hasManualSelected() && this.hasNotMappedSelected();
}

  /* ===============================
     SINGLE ROW ACTIONS
  =============================== */

  onEditRow(rowData: any): void {
    console.log('Edit item:', rowData);
    // Implement single row edit logic
  }

  onDeleteRow(rowData: any): void {
    if (confirm('Are you sure you want to delete this item?')) {
      console.log('Delete item:', rowData);
      // Implement single row delete logic
    }
  }

  /* ===============================
     DROPDOWN FILTERS
  =============================== */

  onProductFilter(value: any): void {
    // if (!this.gridApi) return;
    
    // if (!value) {
    //   this.gridApi.setFilterModel(null);
    //   return;
    // }
    
    // const filterInstance = this.gridApi.getFilterInstance('product');
    // filterInstance?.setModel({
    //   type: 'equals',
    //   filter: value
    // });
    // this.gridApi.onFilterChanged();
    console.log("Selected product ",value);
      this.selectedProductId = value;
      this.currentPage = 1; // reset pagination

      this.loadGridData();
  }

  onAlertFilter(value: any): void {
    // if (!this.gridApi) return;
    
    // if (!value) {
    //   this.gridApi.setFilterModel(null);
    //   return;
    // }
    
    // const filterInstance = this.gridApi.getFilterInstance('ruleName');
    // filterInstance?.setModel({
    //   type: 'equals',
    //   filter: value
    // });
    // this.gridApi.onFilterChanged();
      console.log("Selected Alert ",value);
      this.selectedAlertId = value;
      this.currentPage = 1; // reset pagination

      this.loadGridData();
  }

   onDataSourceFilter(value: any): void {
    // if (!this.gridApi) return;
    
    // if (!value) {
    //   this.gridApi.setFilterModel(null);
    //   return;
    // }
    
    // const filterInstance = this.gridApi.getFilterInstance('source');
    // filterInstance?.setModel({
    //   type: 'equals',
    //   filter: value
    // });
    // this.gridApi.onFilterChanged();

      console.log("Selected Source ",value);
      this.selectedSource = value;
      this.currentPage = 1; // reset pagination

      this.loadGridData();
  }

  /* ===============================
     UI ENHANCEMENTS
  =============================== */

  getKpiPercentage(value: number, total: number): string {
    return `${Math.round((value / total) * 100)}%`;
  }

  refreshData(): void {
    console.log('Refreshing data...');
    this.isGridLoading = true;
    
    // Simulate API call
    setTimeout(() => {
      this.isGridLoading = false;
      if (this.gridApi) {
        this.gridApi.refreshCells();
      }
    }, 1000);
  }

  exportData(): void {
    if (!this.gridApi) return;
    
    console.log('Exporting data...');
    this.gridApi.exportDataAsCsv({
      fileName: 'alert-product-mapping.csv',
      skipColumnGroupHeaders: true,
      skipColumnHeaders: false,
      skipRowGroups: true,
      processCellCallback: (params) => {
        // Custom formatting if needed
        return params.value;
      }
    });
  }

  /* ===============================
     CLEANUP
  =============================== */

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onScroll() {
    this.updateArrowVisibility();
  }

  updateArrowVisibility() {
   
  }
  
  
 goToFirst() {
    // this.gridApi.paginationGoToFirstPage();
    // this.onPageChange();
    this.currentPage = 1;
    this.loadGridData();  
  }

  goToPrevious() {
    // this.gridApi.paginationGoToPreviousPage();
    // this.onPageChange();
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadGridData();
    }  
  }

  goToNext() {
    // this.gridApi.paginationGoToNextPage();
    // this.onPageChange();
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadGridData();
    }  
  }

  goToLast() {
    // this.gridApi.paginationGoToLastPage();
    // this.onPageChange();
    this.currentPage = this.totalPages;
    this.loadGridData(); 
  }

onPageChange() {
    // FIRST: Get the current page from the grid (grid is 0-based)
    const gridCurrentPage = this.gridApi.paginationGetCurrentPage();
    
    // SECOND: Update our 1-based page number
    this.currentPage = gridCurrentPage + 1;
    
    // THIRD: Log the new page value
    console.log('Page changed - Grid page:', gridCurrentPage, 'UI page:', this.currentPage);
    
    // FOURTH: Load data for the new page
    this.loadGridData();
}

  onRefresh(){
    this.loadGridData();
    this.loadSummaryData();
  }

  loadGridData(){
    this.spinner.start();
     // Use currentPage for API call (convert to 0-based)
    console.log(`Loading page ${this.currentPage} (API page: ${this.currentPage - 1})`);

       let mappingType = null;

      if (this.showUnMappedProducts) {
        mappingType = 'NotMapped';
      }

 this.alertRuleService.getAllAlertProductMApping(
   this.currentPage -1 ,
   this.pageSize,
   this.selectedProductId,
  this.selectedSource,
  this.selectedAlertId,
  mappingType
 ).subscribe((res:any)=>{

   this.rowData = res.rows;

   this.totalRows = res.totalCount;

   this.totalPages = Math.ceil(this.totalRows / this.pageSize);

           // Update display values
        this.startRow = ((this.currentPage - 1) * this.pageSize) + 1;
        this.endRow = Math.min(this.currentPage * this.pageSize, this.totalRows);

        console.log(`Data loaded - Current page: ${this.currentPage}, Total pages: ${this.totalPages}`);

      this.spinner.stop();

 });

}

loadProductList(){
    this.jsignalsService.getProductList().subscribe({
  next: (response: any[]) => {
    try {
      // Validate response type before mapping
      if (!Array.isArray(response)) {
        throw new Error('Invalid response type: expected an array.');
      }

      // Map both id and name safely
      this.productOptions = response.map((item, index) => {
        if (!item || typeof item !== 'object') {
          throw new Error(`Invalid item at index ${index}: ${JSON.stringify(item)}`);
        }

        return {
          id: item.id,
          name: item.name
        } as Product;
      });

      // Initialize your displayed & selected arrays
      this.productOptions = [...this.productOptions];
      this.selectedProductId = this.productOptions[0]?.id || null;

      this.loadGridData();

    } catch (error) {
      console.error(' Error while processing product list:', error);
      
    }
  },
  error: (err) => {
    console.error(' API Error while fetching product list:', err);
  },
});
}

loadAllActiveAlerts(){
  this.alertRuleService.getAllActiveAlertRulesLib().subscribe({
    next: (alerts: any[]) => {
      this.alertOptions = alerts;
    },
    error: (err) => {
      console.error(' API Error while fetching active alerts:', err);
    }
  });
}

loadSummaryData(){
  this.spinner.start();
    this.alertRuleService.getAlertProductMappingSummary().subscribe({
    next: (summary: any) => {
      this.totalProducts = summary.totalProducts;
      this.totalAlerts = summary.totalAlertRules;
      this.activeAlerts = summary.activeAlertRules;
      this.mappedProducts = summary.mappedProducts;
      this.unmappedProducts = summary.unmappedProducts;
      this.defaultCount = summary.defaultMappedProducts;
       this.spinner.stop();
    },
    error: (err) => {
      console.error(' API Error while fetching summary:', err);
       this.spinner.stop();
    }
  });
}

  buildLogicText(logic: any): string {
    if (!logic) return "";

    // CASE 1: Group condition (AND / OR)
    if (logic.rules && logic.rules.length) {
      return (
        "(" +
        logic.rules
          .map((r: any) => this.buildLogicText(r))
          .filter(Boolean)
          .join(` ${logic.condition} `) +
        ")"
      );
    }

    // CASE 2: Single rule (leaf)
    if (logic.fieldName && logic.operator !== undefined) {
      return `${logic.fieldName} ${logic.operator} ${logic.value}`;
    }

    return "";
  }

 onShowUnmappedProducts(event){
    console.log(event);
    this.currentPage = 1;
    this.showUnMappedProducts = event.checked;
    this.loadGridData();

  }

}
